<template>
  <b-modal
    id="modal-center"
    centered
    title="Caller Locations"
    :show="show"
    dialog-class="geo-location-modal"
    :header-class="isDarkMode ? 'dark' : ''"
    hide-footer
    @close="handleClose"
    @shown="initializeMap"
  >
    <div id="new-map-id"></div>
  </b-modal>
</template>

<script>
/* eslint-disable */
import * as L from "leaflet";
import "leaflet.markercluster";
import "leaflet/dist/leaflet.css";
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import markerIconPng from "leaflet/dist/images/marker-icon.png";

export default {
  props: {
    show: Boolean,
    geolocationActivityData: Array,
    isDarkMode: Boolean,
  },
  methods: {
    handleClose() {
      this.$emit("closeModal");
    },
    initializeMap() {
      const baseLayer = L.tileLayer(
        "http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        {
          attribution:
            "Map data &copy; <a href=\"https://openstreetmap.org\">OpenStreetMap</a>",
        }
      );

      const map = new L.Map("new-map-id", {
        center: new L.LatLng(37.8, -96),
        zoom: 2,
      });
      map.addLayer(baseLayer);

      if (
        this.geolocationActivityData &&
        this.geolocationActivityData.length > 0
      ) {
        const LeafIcon = L.Icon.extend({
          options: {
            iconSize: [25, 41],
            iconAnchor: [12, 41]
          }
        });
        const markers = L.markerClusterGroup();
        const markerIcon = new LeafIcon({ iconUrl: markerIconPng });
        this.geolocationActivityData.forEach((value) => {
          const marker = L.marker([value.lng, value.lat], { icon: markerIcon });
          markers.addLayer(marker);
        });
        map.addLayer(markers);
      }
    },
  },
};
</script>



<style lang="scss">
.geo-location-modal {
  & .modal-content {
    width: 100%;
    height: 100%;
  }
  & .dark {
    & .close {
      color: #b2b9bf !important;
    }
  }

  &.modal-dialog-centered {
    min-width: 100vw;
    height: 100vh !important;
    margin: 0 !important;
  }
}

#new-map-id {
  height: 100%;
  border-radius: 1rem;
}
</style>